export const translation = {
  nav: {
    home: 'Hjem',
    guides: 'Guides',
    categories: 'Kategorier',
    article: 'Artikel',
    shoppingGuide: 'Købsguide',
    explore: 'Udforsk Spreadsheet',
    buyNow: 'Køb Nu',
  },
  hero: {
    eyebrow: 'ALLCHINABUY RESSOURCECENTER',
    headline: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsguides På Ét Sted',
    subheadline: 'Udforsk organiserede AllChinaBuy spreadsheet-ressourcer, produktkategorier, betroede sælger-guides, QC-informationer, forsendelsesomkostninger, lager-tip, anmeldelser og praktiske købsguides, før du køber.',
    ctaExplore: 'Udforsk AllChinaBuy Spreadsheet',
    ctaBrowse: 'Gennemse Købsguides',
    trustLine: 'Uafhængig Ressource • Praktiske Guides • Opdateret Indhold',
  },
  whatIs: {
    h2: 'Hvad er AllChinaBuy Spreadsheet?',
    copy: 'AllChinaBuy Spreadsheet er en struktureret ressource, der gør produktopdagelse nemmere. Udforsk produkter, kategorier, sælgere, QC-informationer, forsendelsesressourcer og købsguides fra ét organiseret sted.',
  },
  everythingNeed: {
    h2: 'Alt Hvad Du Har Brug for at Recherche AllChinaBuy-produkter',
    cards: {
      productDiscovery: 'Produktopdagelse',
      productDiscoveryDesc: 'Udforsk organiserede produkt- og kategoriressourcer.',
      sellerResearch: 'Sælgerrecherche',
      sellerResearchDesc: 'Sammenlign sælgerinformationer og købshensyn.',
      qcInfo: 'QC-informationer',
      qcInfoDesc: 'Forstå kvalitetskontrol-billeder og deres begrænsninger.',
      shippingGuides: 'Forsendelsesguides',
      shippingGuidesDesc: 'Lær om forsendelsesmetoder, omkostninger og almindelige spørgsmål.',
    },
  },
  popularResources: {
    h2: 'Populære AllChinaBuy-ressourcer',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Anmeldelse',
    shippingCost: 'AllChinaBuy Forsendelsesomkostninger',
    warehouse: 'AllChinaBuy Lager',
    coupon: 'AllChinaBuy Kupon',
    discountCode: 'AllChinaBuy Rabatkode',
    legit: 'AllChinaBuy Legitim',
    qc: 'AllChinaBuy QC',
    trustedSellers: 'Betroede Sælgere',
    buyingGuides: 'Købsguides',
  },
  productCategories: {
    h2: 'Udforsk AllChinaBuy-produktkategorier',
    shoes: 'Sko',
    hoodiesSweaters: 'Hoodies/Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jakker',
    pantsShorts: 'Bukser/Shorts',
    headwear: 'Hovedbeklædning',
    sets: 'Sæt',
    underwear: 'Undertøj',
    jersey: 'Trøjer',
    accessories: 'Tilbehør',
    bags: 'Tasker',
    belts: 'Bælter',
    perfumes: 'Parfumer',
    otherStuff: 'Andet',
  },
  howToUse: {
    h2: 'Sådan Bruger Du AllChinaBuy Spreadsheet',
    steps: {
      step1: 'Vælg en kategori.',
      step2: 'Recherche produkter og sælgere.',
      step3: 'Sammenlign muligheder.',
      step4: 'Gennemgå QC-informationer.',
      step5: 'Tjek lager- og forsendelsesinformationer.',
      step6: 'Træf en informeret beslutning.',
    },
    cta: 'Start Udforskning af Spreadsheet',
  },
  researchFirst: {
    h2: 'Recherche Først. Køb Med Mere Selvtillid.',
    copy: 'Forståelse af sælgerrecherche, produktinformation, QC-processer, forsendelsesmuligheder og købsrisici hjælper dig med at træffe klogere beslutninger. Vores guides går dig igennem hvert trin af rechercheprocessen.',
  },
  stayInformed: {
    h2: 'Hold Dig Informeret Før Du Køber',
    copy: 'Bekræft altid produktinformation, sælgerdetaljer, betalingsinformation, forsendelsesbetingelser og URL\'er. Intet spreadsheet kan garantere kvalitet, ægthed eller transaktionsresultater.',
    cta: 'Læs Sikkerhedsguiden',
  },
  readyToExplore: {
    h2: 'Klar til at Udforske AllChinaBuy?',
    copy: 'Start med AllChinaBuy Spreadsheet, sammenlign produkter og sælgere, lær om QC og forsendelse, og brug vores købsguides til at træffe bedre informerede beslutninger.',
    ctaExplore: 'Udforsk AllChinaBuy Spreadsheet',
    ctaVisit: 'Besøg Hovedwebsted',
  },
  footer: {
    disclaimer: 'Dette websted er en uafhængig informationsressource. Information kan ændre sig og bør verificeres uafhængigt før køb.',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.',
    links: {
      home: 'Hjem',
      guides: 'Guides',
      safety: 'Sikkerhed',
      contact: 'Kontakt',
    },
  },
  categories: {
    shoes: 'Sko',
    hoodiesSweaters: 'Hoodies/Sweaters',
    tShirts: 'T-Shirts',
    jackets: 'Jakker',
    pantsShorts: 'Bukser/Shorts',
    headwear: 'Hovedbeklædning',
    sets: 'Sæt',
    underwear: 'Undertøj',
    jersey: 'Trøjer',
    accessories: 'Tilbehør',
    bags: 'Tasker',
    belts: 'Bælter',
    perfumes: 'Parfumer',
    otherStuff: 'Andet',
  },
  pillarArticles: {
    h2: 'Søjle-Guides & Ressourcer',
  },
  article: {
    readMore: 'Læs Mere',
    relatedArticles: 'Relaterede Artikler',
    backToHome: 'Tilbage til Hjem',
  },
};